const handleDeleteGroupModalEquipService = {
  confirm: 'Deseja realmente deletar a seção',
  title: 'DELETAR SEÇÃO DO CHECKLIST'
};

export default handleDeleteGroupModalEquipService;
